import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/functions';
import {Expo} from 'vexpo-components';
import './index.css';
import registerServiceWorker from './registerServiceWorker';
import Unavailable from './unavailable';

// Initialize Firebase
var config = {
  apiKey: "AIzaSyC4ogxRXEYfTPMrZ5u1avdupsmIOxojC-A",
  authDomain: "vexpo-shows.firebaseapp.com",
  databaseURL: "https://vexpo-shows.firebaseio.com",
  projectId: "vexpo-shows",
  storageBucket: "vexpo-shows.appspot.com",
  messagingSenderId: "95835937652"
};
firebase.initializeApp(config);
const db = firebase.firestore();
const settings = {timestampsInSnapshots: true};
db.settings(settings);

// Determine showID
var showID;
var parts = window.location.pathname.split('/');
switch(parts[1]) {
  case 'archive':
    showID = parts[2];
    break;
  case 'sample':
    showID = 'sample';
    break;
  default:
    showID = (new Date()).getFullYear().toString();
    break;
}

var host = window.location.host.replace('www.', '');
if(host.includes("localhost") || host.includes('192')) {
  host = "holidaysportsmanshow.com";
  showID = "experiment"
}

// Determine the expoID
db.collection('hosts').doc(host)
  .get().then(doc => {
    if(!doc.exists) {
      console.error("No Host Document");
      ReactDOM.render(<Unavailable/>, document.getElementById('root'));
      return;
    }
    const expoID = doc.data().expoID;
    // Load the expo data
    db.collection('expos').doc(expoID)
      .collection('shows').doc(showID)
      .get().then(doc => {
        console.error("No Expo Document");
        if(!doc.exists) {
          ReactDOM.render(<Unavailable />, document.getElementById('root'));
          return ;
        }
        const current = doc.data().current;
        //console.log('current', current);
        db.collection('expos').doc(expoID)
          .collection('shows').doc(showID)
          .collection('releases').doc(current)
          .get().then(doc => {
            if(!doc.exists) {
              console.error("No Release Document");
              ReactDOM.render(<Unavailable />, document.getElementById('root'));
              return;
            }
            var expo = doc.data();
            expo.expoID = expoID;
            expo.showID = showID;
            ReactDOM.render(<Expo {...expo} firebase={firebase} />, document.getElementById('root'));
          });
      });
  });



registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js